import { FilterPresetsListCode } from '../types';

export interface FiltersPresetsRouter {
  goToPresetEdit(id: string, listCode: FilterPresetsListCode): void;

  goToList(listCode: FilterPresetsListCode): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FiltersPresetsRouter = Symbol('FiltersPresetsRouter');
